import { useSelector } from "react-redux";
import { ReducerType } from "../../../storeManager/ReducerType";
import { LoginInterface } from "../../../Interfaces/LoginInterface";
import useFetch from "../../../_services/fetch";
import { RaytebRequests } from "../../../_services";
import { useEffect } from "react";

const NotificationManager = () => {
    const user = useSelector<ReducerType, LoginInterface>(
        (state) => state.reducerUser
    )
    const getKeysRequest = useFetch<any>({
        request: RaytebRequests.Notification_GetNotificationKeys(),
        onSuccess(data) {
            checkPermissionNotification(data.PublicKey, data.PrivateKey)
        },
    })
    const createNotClientRequest = useFetch<any, CreateNotificationClientInterface>({
        request: RaytebRequests.Notification_AddOrUpdateClient(),
        onSuccess(data) {
        },
    })
    // const checkExistsUserRequest = useFetch<boolean, ExistsClientForUserNotiInputModel>({
    //     request: RaytebRequests.Notification_ExistsClientForUser(),
    //     onSuccess(data) {
    //         if (!data) {
    //             getKeysRequest.reFetch()
    //         }
    //     },
    // })
    const checkPermissionNotification = (publickKey, privateKey) => {
        Notification.requestPermission().then(function (val) {
            if (val === "granted")
                navigator.serviceWorker.register('./sw.js');
            if (navigator.serviceWorker) {
                var reg = navigator.serviceWorker.ready.then(function (result) {
                    var subscriptionParams = {
                        applicationServerKey: urlBase64ToUint8Array(publickKey),
                        userVisibleOnly: true
                    };
                    var getSub = result.pushManager.getSubscription().then(function (subscribe) {
                        const addSubscribe = () => {
                            result.pushManager.subscribe(subscriptionParams).then(function (response) {
                                const p256dh = base64Encode(response.getKey("p256dh")!);
                                const Auth = base64Encode(response.getKey("auth")!);
                                const EndPoint = response.endpoint;
                                createNotClientRequest.reFetch({
                                    auth: Auth,
                                    endPoint: EndPoint,
                                    p256dh: p256dh,
                                    privateKey: privateKey,
                                    publicKey: publickKey,
                                    personCode: user.userData?.code!,
                                    iP: null,
                                    userAgent: null,
                                    browserUniqueKey: generateBrowserFingerprint().toString()
                                })
                            });
                        }
                        if (subscribe === null)
                            addSubscribe();
                        else {
                            subscribe.unsubscribe().then(() => {
                                addSubscribe()
                            })
                        }
                    });
                })
            }
        })
    }

    useEffect(() => {
        // if (user.userData && Notification.permission !== 'denied') {
        //     checkExistsUserRequest.reFetch({ browserUniqueKey: generateBrowserFingerprint().toString(), personCode: user.userData.code! })
        // }

        getKeysRequest.reFetch()
    }, [])
    return <></>
}
export default NotificationManager;


// فانگشن ها برای base64 هستن
const base64Encode = (arrayBuffer: ArrayBuffer) => {
    return btoa(String.fromCharCode.apply(null, (new Uint8Array(arrayBuffer) as unknown as number[])));
}
const urlBase64ToUint8Array = (base64String) => {
    var padding = '='.repeat((4 - base64String.length % 4) % 4);
    var base64 = (base64String + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/');

    var rawData = window.atob(base64);
    var outputArray = new Uint8Array(rawData.length);

    for (var i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}

// ساخت شناسه منحصر به فرد برای مرورگر

function generateBrowserFingerprint() {
    const navigatorInfo = window.navigator;
    const screenInfo = window.screen;

    // جمع‌آوری اطلاعات کلیدی مرورگر و دستگاه
    const data = [
        navigatorInfo.userAgent,                // مرورگر و سیستم‌عامل
        navigatorInfo.language || '',          // زبان مرورگر
        navigatorInfo.platform || '',          // پلتفرم (مانند ویندوز، مک، لینوکس)
        screenInfo.width + 'x' + screenInfo.height, // ابعاد صفحه نمایش
        screenInfo.colorDepth || '',           // عمق رنگ
        new Date().getTimezoneOffset(),        // منطقه زمانی کاربر
        getCanvasFingerprint(),                // اثر انگشت Canvas
    ].join('::');

    // هش کردن داده‌ها برای تولید کد یکتا
    return hashString(data);
}

// تولید اثر انگشت Canvas
function getCanvasFingerprint() {
    try {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        context!.textBaseline = 'top';
        context!.font = '14px Arial';
        context!.fillText('Browser Fingerprint', 10, 10);
        return canvas.toDataURL();
    } catch (error) {
        return 'unsupported';
    }
}

// تابع هش ساده برای تولید یک شناسه کوتاه
function hashString(string) {
    let hash = 0, i, chr;
    if (string.length === 0) return hash;
    for (i = 0; i < string.length; i++) {
        chr = string.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0; // تبدیل به عدد صحیح 32 بیتی
    }
    return hash.toString(16); // تبدیل به رشته هگزادسیمال
}
